import * as React from 'react';

import PropTypes from 'prop-types';

// @ts-ignore
import LeadActions from 'actions/LeadActions';
// @ts-ignore
import PromptActions from 'actions/PromptActions';
// @ts-ignore
import SetupActions from 'actions/SetupActions';
import CurrentUser from 'auth/CurrentUser';
import BoxFooter from 'components/BoxFooter';
import Link from 'components/Link';
import { PromptNames } from 'constants/PromptConstants';
import JoinGroupModal from 'groups/components/JoinGroupModal';
// @ts-ignore
import PromptStore from 'stores/PromptStore';

class SetupSubscription extends React.Component<{}> {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  componentDidMount() {
    if (!PromptStore.hasDismissed(PromptNames.NUX_SETUP_FIRST_SUBSCRIPTION)) {
      PromptActions.recordDismissal(PromptNames.NUX_SETUP_FIRST_SUBSCRIPTION);
    }
  }

  onJoinGroup = () => {
    SetupActions.joinGroupDuringSetup();
    LeadActions.loadLeads(true);

    this.context.router.push('/information_required');
  };

  onSkip = () => {
    this.context.router.push('/information_required');
  };

  renderCreateClass = () => {
    if (CurrentUser.getUser().canCreateGroups()) {
      return (
        <BoxFooter>
          {'Or '}
          <Link
            className="SetupSubscription-CreateClass"
            onClick={() => this.context.router.push('/setup/class')}
            eventElementName="SetupSubscription-CreateClass">
            create a class
          </Link>
        </BoxFooter>
      );
    } else {
      return null;
    }
  };

  render() {
    return (
      <JoinGroupModal
        modal={false}
        footer={this.renderCreateClass()}
        onRequestHide={this.onSkip}
        onJoin={this.onJoinGroup}
      />
    );
  }
}

export default SetupSubscription;
